import React from 'react'

import translations from './translations.json'

type DotNotation<T, P extends string | number = ''> = {
  [K in keyof T]: K extends string
    ? T[K] extends Record<string, any>
      ? `${P extends '' ? '' : `${P}.`}${K}` | DotNotation<T[K], `${P extends '' ? '' : `${P}.`}${K}`>
      : `${P extends '' ? '' : `${P}.`}${K}`
    : never
}[keyof T]

type TranslationKeys = DotNotation<typeof translations>

export function translate(
  key: TranslationKeys,
  params?: Record<string, string | number | React.ReactNode>
): string | React.ReactNode {
  const keys = key.split('.') as string[]

  let textOrObject: any = translations

  for (const key of keys) {
    if (textOrObject && key in textOrObject) {
      textOrObject = textOrObject[key]
    } else {
      return keys[keys.length - 1]
    }
  }

  if (typeof textOrObject === 'string') {
    if (params) {
      const regex = /{{\s*(\w+)(?::(\w+))?\s*}}/g

      return textOrObject.split(regex).map((segment, index) => {
        if (index % 3 === 1) {
          const key = segment.trim()
          const componentType = textOrObject.split(regex)[index + 1]?.trim()

          if (componentType && componentType === 'component' && params[key]) {
            return React.cloneElement(params[key] as React.ReactElement, {
              key: `${key}-${index}`
            })
          }

          return params[key] || `{{${key}}}`
        }
        return segment
      })
    }
    return textOrObject
  }

  return typeof textOrObject === 'string' ? textOrObject : keys[keys.length - 1]
}
